export default function($) {

  var owlHome = $('.homepage-slider');
  var owlThumbsProduct = $('.product-thumbnails-slider');
  var owlGalleryProduct = $('.product-gallery-slider');

  owlHome.owlCarousel({
    nav: false,
    dots: true,
    dotsData: true,
    items:1,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    loop: true,
    autoplay: false,
  });

  $( '.homepage-slider .owl-dot' ).on( 'click', function() {
    owlHome.trigger('to.owl.carousel', [$(this).index(), 300]);
    $( '.owl-dot' ).removeClass( 'active' );
    $(this).addClass( 'active' );
  })

  owlThumbsProduct.owlCarousel({
    nav: false,
    dots: true,
    margin: 16,
    loop: false,
    responsive: {
      0: {
        items: 3
      },
      460: {
        items: 4
      },
      640: {
        items: 6
      },
      960: {
        items: 4
      },
    }
  });

  owlGalleryProduct.owlCarousel({
    items: 1,
    loop: false,
    dots: false,
    nav: false,
    mouseDrag: false,
    URLhashListener: true,
    startPosition: 'URLHash'
});
}
